import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import ProductPreview from '../addtocart/ProductPreview';
import Translatable from '../common/Translatable';
import Heading from '../heading/Heading';
import { VerticalSpacer } from '../styles/Spacer';

const PatternSewpatShortDescription = ({ sewpatTitle, patternTitle, patternId, fabricLabel }) => {
    const Flex = styled.div`
        display: flex;
        align-items: flex-start;
        flex-direction: row;

        & .label {
          max-width: 5em;

          &::after {
            content: ': ';
          }
        }
    `;

    const FlexItem = styled.div`
        max-width: 50%;
        margin: 0;
    `;

    return (
        <Flex>
            <FlexItem>
                <Translatable
                    message='SEWPAT_SHORT'
                    className='schnoffle-bold label'
                />
                <FormattedMessage
                    id='SEWPAT_SHORT_DESCRIPTION'
                    defaultMessage={'{sewpatTitle} von Schnittmuster Berlin'}
                    values={{ sewpatTitle }}
                />
                <VerticalSpacer space={8} />
                <Translatable
                    message='PATTERN_TITEL_LABEL'
                    className='schnoffle-bold label'
                />
                <FormattedMessage
                    id='PATTERN_SHORT_DESCRIPTION'
                    defaultMessage={'{patternTitle} ({patternId}) auf {fabricLabel} von www.stoff.love'}
                    values={{
                        patternTitle,
                        patternId,
                        fabricLabel,
                    }}
                />
                <VerticalSpacer space={10} />
                <Heading
                    level={5}
                    text={<Translatable message={'RECOLOR_HELP_TITLE'} />}
                />
                {<Translatable
                    message={'RECOLOR_HELP_TEXT'}
                />}

            </FlexItem>

            <FlexItem>
                <ProductPreview />
            </FlexItem>
        </Flex>
    );
};

export default PatternSewpatShortDescription;



// WEBPACK FOOTER //
// ./src/components/pattern/PatternSewpatShortDescription.js